import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { InputComponent } from './input.component';

@NgModule({
  declarations: [
    InputComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
  ],
  exports: [
    InputComponent,
  ],
  providers: [],
})
export class InputModule { }



// WEBPACK FOOTER //
// ./src/app/common/components/InputComponent/input.module.ts